import { render, staticRenderFns } from "./SortableList.vue?vue&type=template&id=41a0c4c1&scoped=true&"
import script from "./SortableList.vue?vue&type=script&lang=js&"
export * from "./SortableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a0c4c1",
  null
  
)

export default component.exports